import { render, staticRenderFns } from "./GameTwitchBookmarks.vue?vue&type=template&id=33feb506&"
import script from "./GameTwitchBookmarks.vue?vue&type=script&lang=js&"
export * from "./GameTwitchBookmarks.vue?vue&type=script&lang=js&"
import style0 from "./GameTwitchBookmarks.vue?vue&type=style&index=0&id=33feb506&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports